import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { error } from 'console';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LifecycleService } from 'src/app/shared/services/lifecycle.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

export interface workflowData {
  edata: any;
}

@Component({
    selector: "app-work-flow-pop-up",
    templateUrl: "./work-flow-pop-up.component.html",
    styleUrls: ["./work-flow-pop-up.component.scss"],
    standalone: false
})
export class WorkFlowPopUpComponent implements OnInit {
  @Input() data: any;
  @Output() closeEvent = new EventEmitter<any>();
  @Output() backToWorkFlow = new EventEmitter<void>();
  backgroundColorScreen: string;
  buttonColor: string;
  validations_form: UntypedFormGroup;
  workflowDto = {
    workflowid: "",
    workflowname: "",
    description: "",
    lifecyclename: "",
    startstates: "",
    starttype: "",
  };
  validation_messages;
  buttonName;
  id: number;
  lifecycleData: any[] = [];
  states: any[] = [];
  gridApi: any;
  lastpage: boolean;
  currentpage: number;
  nextpage: number;
  nextpageplusone: number;
  totalpages: number;
  pagesize: number;
  lifecycleRequestDto: any;
  columnDefs;
  components: any;
  defaultColDef;
  buttonIdList;
  rowClassRules;
  paginationNumberFormatter;
  paginationPageSize;
  rowData;
  showWorkflowForm = false;
  workflowSteps: any[] = [];
  selectedStepForEdit: any = null;
  workflowId;
  isEditMode = false;
  originalWorkflowData: any;
  constructor(
    private localStorageSettings: LocalStorageSettingsService,
    private snackbar: MatSnackBar,
    private validation: validationmethod,
    private errorMessages: ErrorMessages,
    private lifecycleservice: LifecycleService,
    private spinner: NgxUiLoaderService,
  ) {
    this.validation_messages = this.errorMessages.workflow;
    this.components = {
      buttonRenderer: Actionbutton,
    };
  }
  /**
   * @Author Shyam
   * @Date 11/03/2026
   *  @Description: Workflow Pop-up Component
   */
  ngOnInit(): void {
    this.formValidation();
    // console.log(this.data.workflowid)
    this.lifecycleservice.getLifecycleDetails().subscribe((response) => {
      console.log(response);
      console.log("Inside lifecycle details");
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", { duration: 3000 });
      } else {
        this.lifecycleData = response as unknown as any[];
        console.log(this.lifecycleData);
        if (this.data) {
          const selectedLifecycle = this.lifecycleData.find(
            (lifecycle) => lifecycle.lifecycleid === this.data.lifecycleId,
          );
          console.log(selectedLifecycle);
          if (selectedLifecycle) {
            console.log(selectedLifecycle);
            this.states = selectedLifecycle.states;
            console.log(this.states);
            const selectId = Number(this.data.startingStatesIds);
            this.validations_form.get("startstates").setValue(selectId);
            const selectedState = this.states.find(
              (state) => state.stateid === selectId,
            );

            if (selectedState) {
              this.workflowDto.starttype = selectedState.statetype;
              this.validations_form
                .get("starttype")
                .setValue(selectedState.statetype);
            }
            // this.workflowDto.startstate = this.states;
          } else {
            this.states = [];
          }
        }
      }
    });

    console.log(this.data);
    if (this.data) {
      console.log("Inside of update");
      this.buttonName = "Update";
      this.isEditMode = false;
      this.originalWorkflowData = { ...this.data };
      this.validations_form.disable();
      this.workflowDto.workflowname = this.data.workflowname;
      this.workflowDto.description = this.data.description;
      this.workflowDto.lifecyclename = this.data.lifecycleId;
      this.workflowDto.workflowid = this.data.workflowid;
      const selectId = Number(this.data.startingStatesIds);
      this.validations_form.get("startstates").setValue(selectId);
      const selectedLifecycle = this.lifecycleData.find(
        (lifecycle) => lifecycle.lifecycleid === this.data.lifecycleId,
      );
      console.log(selectedLifecycle);
      if (selectedLifecycle) {
        console.log(selectedLifecycle);
        this.states = selectedLifecycle.states;
        console.log(this.states);

        // this.workflowDto.startstate = this.states;
      } else {
        this.states = [];
      }
      this.retrieveWorkflowstepsBasedOnWorkflowId();
    } else {
      this.isEditMode = true;
      this.buttonName = "Save";
    }
    this.columnDefs = [
      {
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        },
        width: 150,
      },
      {
        headerName: "Step Name",
        headerTooltip: "Step Name",
        tooltipValueGetter: (params) => "Step Name : " + params.value,
        field: "stepname",
        filter: "agTextColumnFilter",
        width: 250,
      },
      {
        headerName: "Type",
        headerTooltip: "Type",
        tooltipValueGetter: (params) => "Type : " + params.value,
        field: "steptype",
        filter: "agTextColumnFilter",
        width: 250,
      },
      {
        headerName: "Description",
        headerTooltip: "Description",
        tooltipValueGetter: (params) => "Description : " + params.value,
        field: "description",
        filter: "agTextColumnFilter",
        width: 250,
      },
      {
        headerName: "Next Steps",
        headerTooltip: "Next Steps",
        tooltipValueGetter: (params) => "Next Steps : " + params.value,
        field: "nextsteps",
        filter: "agTextColumnFilter",
        width: 250,
      },
    ];
    this.backgroundColorScreen =
      this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      workflowname: new FormControl("", [
        Validators.required,
        this.validation.noWhitespaceValidator,
        this.validation.specialCharacterValidator,
      ]),
      description: new FormControl("", []),
      lifecyclename: new FormControl("", [Validators.required]),
      startstates: new FormControl("", [Validators.required]),
      starttype: new FormControl("", [Validators.required]),
    });
  }

  onSubmit() {
    if (!this.validations_form.valid) {
      this.validations_form.markAllAsTouched();
      this.validation.validateAllFormFields(this.validations_form);
      this.validation.getvalidationmessage();
      return;
    } else {
      if (this.buttonName == "Update") {
        this.id = this.data.workflowid;
      } else {
        this.id = 0;
        this.workflowSteps = [
          {
            stepid: 0,
            stepname: "Start",
            steptype: "START",
            description: "",
            nextsteps: "END_AUTO",
          },
          {
            stepid: 0,
            stepname: "End",
            steptype: "END",
            description: "",
            nextsteps: null,
          },
        ];
      }
      const requestData = {
        workflowid: this.id,
        workflowname: this.workflowDto.workflowname,
        description: this.workflowDto.description,
        lifecycleid: this.workflowDto.lifecyclename,
        startstates: this.workflowDto.startstates,
        workflowSteps: this.workflowSteps,
      };
      console.log(requestData);
      this.lifecycleservice
        .createWorkflow(requestData)
        .subscribe((response) => {
          console.log(response);
          if (response.error == true) {
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 3000,
            });
          } else {
            this.workflowDto.workflowid = response.workflowid;
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 3000,
            });
            this.closeEvent.emit(response.data);
          }
        });
    }
  }

  onCancel() {
    this.isEditMode = false;
    // this.buttonName = "Save";
    // this.closeEvent.emit();
    this.validations_form.patchValue({
      workflowname: this.originalWorkflowData.workflowname,
      description: this.originalWorkflowData.description,
      lifecyclename: this.originalWorkflowData.lifecycleId,
      startstates: Number(this.originalWorkflowData.startingStatesIds),
    });

    // also reset DTO
    this.workflowDto.workflowname = this.originalWorkflowData.workflowname;
    this.workflowDto.description = this.originalWorkflowData.description;
    this.workflowDto.lifecyclename = this.originalWorkflowData.lifecycleId;
    this.workflowDto.startstates = this.originalWorkflowData.startingStatesIds;

    this.validations_form.disable();
  }

  onLifecycleChange(event) {
    console.log("Changing lifecycle");
    console.log(event.value);
    this.workflowDto.lifecyclename = event.value;
    const selectedLifecycle = this.lifecycleData.find(
      (lifecycle) => lifecycle.lifecycleid === event.value,
    );
    console.log(selectedLifecycle);
    if (selectedLifecycle) {
      console.log(selectedLifecycle);
      this.states = selectedLifecycle.states;
      console.log(this.states);
      // this.workflowDto.startstate = this.states;
    } else {
      this.states = [];
    
    }
     this.validations_form.get("startstates").reset();
  this.validations_form.get("starttype").reset();
  this.workflowDto.startstates = "";
  this.workflowDto.starttype = "";
  }

  onStartStateChange(event) {
    console.log("Changing start state");
    console.log(event.value);
    this.workflowDto.startstates = event.value;
    const selectedState = this.states.find(
      (state) => state.stateid === event.value,
    );
    console.log(selectedState);
    if (selectedState) {
      this.workflowDto.starttype = selectedState.statetype;
      this.validations_form.get("starttype").setValue(selectedState.statetype);
    } else {
      this.workflowDto.starttype = "";
      this.validations_form.get("starttype").setValue("");
    }
  }

  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1;
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1;
      this.nextpageplusone =
        this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalpages = this.gridApi.api.paginationGetTotalPages();
    }
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize;
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next");
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous");
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first");
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last");
    this.gridApi.api.paginationGoToLastPage();
  }
  onGridReady(params) {
    this.gridApi = params;
    params.api.setGridOption('rowData', []);
    this.gridApi.api.setGridOption('rowData', this.rowData || []);
  }

  editIcon(params) {
    console.log(params.rowData);
    const steps = params.rowData;
    this.showWorkflowForm = true;
    this.selectedStepForEdit = {
      ...steps,
      workflowid: this.workflowDto.workflowid,
    };
  }
  deleteIcon(params) {
    console.log(params.rowData);
    if (confirm("Are you sure you want to delete this record?")) {
      this.spinner.start();
      this.lifecycleservice
        .deleteWorkflowSteps(params.rowData.stepid)
        .subscribe((response) => {
          console.log(response);
          this.spinner.stop();
          if (response.error == true) {
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 3000,
            });
          } else {
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 3000,
            });
            this.onGridReady(this.gridApi);
          }
        });
    }
  }

  openSaveForm(params) {
    console.log("Inside of work");
    if (this.workflowDto && this.workflowDto.workflowid) {
      this.workflowId = this.workflowDto.workflowid;
      this.selectedStepForEdit = null;
      this.showWorkflowForm = true;
    } else {
      this.snackbar.open(
        "Please save the workflow before inserting steps.",
        "OK",
        {
          duration: 5000,
        },
      );
    }
  }

  closeWorkflowForm(stepPayload: any) {
    this.showWorkflowForm = false;
    this.retrieveWorkflowstepsBasedOnWorkflowId();

    console.log(this.workflowSteps);
    //   this.rowData = this.workflowSteps.map(step => ({
    //     ...step,
    //   stepname: step.workflow?.stepname,
    //   steptype: step.workflow?.steptype,
    //   description: step.workflow?.description,
    //   nextsteps: this.getNextSteps(step) // custom logic
    // }));

    console.log(this.rowData);
  }

  getNextSteps(step: any): string {
    if (step.stepType === "DECISION") {
      return step.taskStep?.rules?.map((r) => r.nextStep).join(", ") || "";
    }
    return "";
  }

  handleBackToWorkflow() {
    this.showWorkflowForm = false;
  }

  backToWorkflowpage() {
    this.backToWorkFlow.emit();
  }

  refreshGrid() {
    console.log("Refreshing grid with workflow steps:", this.workflowSteps);
    this.rowData = this.workflowSteps.map((step) => ({
      ...step,
      stepname: step.stepname,
      steptype: step.steptype,
      description: step.description,
      nextsteps: step.nextsteps,
      taskmode: step.taskmode,
    }));

    this.gridApi.api.setGridOption('rowData', this.rowData);
  }

  retrieveWorkflowstepsBasedOnWorkflowId() {
    this.spinner.start();
    this.lifecycleservice
      .retrieveWorkflowSteps(this.data.workflowid)
      .subscribe((response) => {
        console.log(response);
        if (response.error === true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "Ok", { duration: 5000 });
        } else {
          this.rowData = response;
          if (this.gridApi) {
            console.log("inside rowdata setting");
            this.gridApi.api.setGridOption('rowData', this.rowData);
          }
          this.spinner.stop();
        }
      });
  }

  enableEdit() {
    this.isEditMode = true;
    this.validations_form.enable();
  }
}